module.exports = __webpack_public_path__ + "img/iland-logo2.72864896.png";